import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/J2_Folder.svg'

const J2Folder: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 20 14'} component={Icon} {...props} fill="currentColor" />
export default J2Folder
